import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Points } from '@styles';

export const SectionAnchor = ({ text = '', isHeartMode = false }) => {
  const handleClick = (event) => {
    try {
      const section = event.target.closest('section');
      const nextSection = section.nextElementSibling;

      if (nextSection) {
        nextSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const ArrowSvg = ({ fill = '#FF5600' }) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 3L8 13" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 9L8 14L3 9" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  const HeartSvg = ({ fill = '#FF5600' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.8933 3.07357C13.5528 2.73291 13.1485 2.46267 12.7036 2.2783C12.2586 2.09392 11.7817 1.99902 11.3 1.99902C10.8183 1.99902 10.3414 2.09392 9.89643 2.2783C9.45145 2.46267 9.04717 2.73291 8.70666 3.07357L8 3.78024L7.29333 3.07357C6.60554 2.38578 5.67269 1.99938 4.7 1.99938C3.72731 1.99938 2.79446 2.38578 2.10666 3.07357C1.41887 3.76137 1.03247 4.69422 1.03247 5.66691C1.03247 6.6396 1.41887 7.57245 2.10666 8.26024L2.81333 8.96691L8 14.1536L13.1867 8.96691L13.8933 8.26024C14.234 7.91974 14.5042 7.51545 14.6886 7.07048C14.873 6.6255 14.9679 6.14857 14.9679 5.66691C14.9679 5.18525 14.873 4.70831 14.6886 4.26334C14.5042 3.81836 14.234 3.41408 13.8933 3.07357V3.07357Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <View onClick={handleClick} $isHeartMode={isHeartMode} data-gtm="nav_click">
      {isHeartMode ? <HeartSvg /> : <ArrowSvg />}
      <Text>{text}</Text>
    </View>
  );
};

const arrowMove = keyframes`
  0% {
    transform: translateY(0);
  }

  35% {
    transform: translateY(4px);
  }

  65% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(4px);
  }
`;

const View = styled.div`
  ${Mixins.transition('background-color, border-color')};
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  padding: 15px 24px;
  background-color: #fcf9f8;
  border-radius: 30px;
  text-align: center;
  border: 1px solid ${Colors.main_beige};

  svg {
    margin-bottom: -3px;
    display: none;
    transform-origin: center;
    transition: ${({ $isHeartMode }) => ($isHeartMode ? 'transform 0.3s ease, fill 0.5s ease' : 'none')};

    @media ${Points.tablet_portrait} {
      display: inline-block;
    }
  }

  &:hover {
    background-color: ${Colors.main_beige};
    border-color: ${Colors.white};

    svg {
      transform: ${({ $isHeartMode }) => ($isHeartMode ? 'scale(1.2)' : 'translateY(4px)')};
      animation: ${({ $isHeartMode }) => ($isHeartMode ? 'none' : arrowMove)} 0.6s ease-in-out;
    }
  }

  &:active {
    svg {
      fill: ${({ $isHeartMode }) => $isHeartMode && '#FF5600'};
    }
  }
`;
const Text = styled.span`
  margin-left: 5px;
  color: #ff5600;
`;
